function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M891.647 531.3a31.517 31.517 0 0030.435-5.362c10.66-8.947 14.002-23.687 16.721-37.336l8.044-40.37-16.84 11.595c-12.11 8.339-24.493 16.945-32.878 29.023s-12.046 28.566-5.308 41.635",
  fill: "#e6e6e6"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M893.087 580.176c-1.705-12.415-3.457-24.99-2.262-37.538 1.062-11.144 4.462-22.029 11.384-30.953a51.491 51.491 0 0113.21-11.972c1.322-.834 2.538 1.26 1.222 2.09a48.952 48.952 0 00-19.363 23.363c-4.215 10.723-4.892 22.41-4.166 33.801.44 6.888 1.37 13.731 2.309 20.565a1.254 1.254 0 01-.845 1.489 1.218 1.218 0 01-1.49-.845z",
  fill: "#f2f2f2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M909.503 558.207a23.2 23.2 0 0020.215 10.433c10.234-.485 18.765-7.627 26.444-14.408l22.715-20.056-15.033-.719c-10.811-.517-21.902-1-32.199 2.334s-19.794 11.358-21.677 22.016",
  fill: "#e6e6e6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M888.27 587.313c8.204-14.516 17.72-30.649 34.722-35.805A38.746 38.746 0 01937.596 550c1.55.134 1.164 2.524-.384 2.39a35.996 35.996 0 00-23.307 6.166c-6.571 4.473-11.688 10.692-16.019 17.287-2.652 4.04-5.028 8.25-7.405 12.455-.76 1.344-2.98.374-2.211-.985z",
  fill: "#f2f2f2"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 107.587,
  cy: 589.838,
  rx: 10.903,
  ry: 4.089,
  fill: "#2f2e41"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 133.755,
  cy: 589.293,
  rx: 10.903,
  ry: 4.089,
  fill: "#2f2e41"
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 274.617,
  cy: 671.802,
  rx: 21.534,
  ry: 6.76,
  transform: "rotate(-29.963 -66.008 799.9)",
  fill: "#2f2e41"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 116.31,
  cy: 532.324,
  r: 43.067,
  fill: "#2f2e41"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M96.684 566.124h13.084v23.442H96.684zM122.852 566.124h13.084v23.442h-13.084z"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 126.4,
  cy: 521.421,
  r: 14.719,
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 242.9,
  cy: 672.421,
  rx: 4.886,
  ry: 4.921,
  transform: "rotate(-45.026 3.58 728.015)",
  fill: "#3f3d56"
});

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 186.302,
  cy: 697.341,
  rx: 21.534,
  ry: 6.76,
  transform: "rotate(-75.125 32.08 692.031)",
  fill: "#2f2e41"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M126.067 545.136c7.907 0 15.32-5.033 15.32-.818s-7.413 16.082-15.32 16.082-15.032-8.323-15.032-12.538 7.125-2.726 15.032-2.726z",
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 676.189,
  cy: 441.783,
  rx: 10.903,
  ry: 4.089,
  fill: "#2f2e41"
});

var _ref15 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 650.022,
  cy: 441.238,
  rx: 10.903,
  ry: 4.089,
  fill: "#2f2e41"
});

var _ref16 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 728.16,
  cy: 523.747,
  rx: 6.76,
  ry: 21.534,
  transform: "rotate(-60.037 541.008 542.005)",
  fill: "#2f2e41"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 667.467,
  cy: 384.269,
  r: 43.067,
  fill: "#2f2e41"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M674.009 418.069h13.084v23.442h-13.084zM647.841 418.069h13.084v23.442h-13.084z"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 657.377,
  cy: 373.366,
  r: 14.719,
  fill: "#fff"
});

var _ref20 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 759.877,
  cy: 524.366,
  rx: 4.921,
  ry: 4.886,
  transform: "rotate(-44.974 520.322 580.128)",
  fill: "#3f3d56"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M672.098 355.474c-17.19-3.839-28.582-9.582-25.105-25.156s20.232-25.087 37.422-21.25 28.306 19.576 24.829 35.15-19.956 15.094-37.146 11.256z",
  fill: "#899689"
});

var _ref22 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 816.475,
  cy: 549.286,
  rx: 6.76,
  ry: 21.534,
  transform: "rotate(-14.875 175.695 892.2)",
  fill: "#2f2e41"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M657.71 397.081c-7.907 0-15.32-5.033-15.32-.818s7.413 16.082 15.32 16.082 15.032-8.323 15.032-12.538-7.126-2.726-15.032-2.726z",
  fill: "#fff"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M215.886 459a102 102 0 11102-102 102.115 102.115 0 01-102 102zm0-184a82 82 0 1082 82 82.093 82.093 0 00-82-82zM447.886 594c-28.3 0-54.479-18.368-73.716-51.72-18.24-31.621-28.284-73.45-28.284-117.78s10.045-86.159 28.284-117.78c19.237-33.352 45.417-51.72 73.716-51.72s54.478 18.368 73.716 51.72c18.24 31.621 28.284 73.45 28.284 117.78s-10.045 86.159-28.284 117.78C502.364 575.632 476.185 594 447.886 594zm0-319c-20.85 0-40.876 14.814-56.392 41.713-16.514 28.63-25.608 66.91-25.608 107.787s9.094 79.157 25.608 107.787C407.01 559.186 427.036 574 447.886 574s40.876-14.814 56.391-41.713c16.514-28.63 25.609-66.91 25.609-107.787s-9.095-79.157-25.609-107.787C488.762 289.814 468.735 275 447.886 275z",
  fill: "#3f3d56"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M307.886 593.543h-184a10 10 0 01-7.212-16.927l146.22-152.219a10 10 0 1114.423 13.855L147.358 573.543h160.528a10 10 0 110 20zM668.886 459a102 102 0 11102-102 102.115 102.115 0 01-102 102zm0-184a82 82 0 1082 82 82.093 82.093 0 00-82-82z",
  fill: "#3f3d56"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M760.886 593.543h-184a10 10 0 01-7.212-16.927l146.22-152.219a10 10 0 1114.423 13.855L600.358 573.543h160.528a10 10 0 010 20zM890.886 594a10 10 0 01-10-10V289.142l-75.823 75.823a10 10 0 01-14.142-14.143l92.894-92.893a10 10 0 0117.07 7.071v319a10 10 0 01-10 10z",
  fill: "#3f3d56"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M137.848 495.994l-7.275-8.697-5.773-6.911-8.375-10.016-5.784-6.909-7.857-9.407a1.135 1.135 0 00-1.932.337l-3.058 8.373-2.373 6.468-3.432 9.377-2.359 6.477-3.432 9.377-2.36 6.466-1.76 4.804a1.05 1.05 0 00-.058.583 1.18 1.18 0 00.241.53 1.124 1.124 0 001.063.386l53.86-9.406a1.064 1.064 0 00.792-.573.844.844 0 00.077-.15 1.18 1.18 0 00.047-.581 1.05 1.05 0 00-.252-.528z",
  fill: "#899689"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M116.425 470.37l-21.003-1.138 2.371-6.468 12.848.697 5.784 6.909zM130.573 487.296l-40.943-2.21 2.36-6.477 32.81 1.776 5.773 6.911zM137.977 497.253a1.064 1.064 0 01-.793.573l-26.186 4.573-27.16-1.47 2.36-6.466z"
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  cx: 100.945,
  cy: 449.225,
  r: 9.019,
  fill: "#899689"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M916.291 269.329l-4.121-10.563-3.268-8.391-4.743-12.164-3.279-8.392-4.446-11.423a1.135 1.135 0 00-1.94-.296l-5.568 6.96-4.311 5.374-6.243 7.793-4.302 5.386-6.243 7.793-4.3 5.375-3.2 3.993a1.05 1.05 0 00-.24.533 1.18 1.18 0 00.06.58 1.124 1.124 0 00.884.705l54.047 8.262a1.064 1.064 0 00.934-.29.844.844 0 00.12-.119 1.18 1.18 0 00.23-.535 1.05 1.05 0 00-.07-.581z",
  fill: "#899689"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M904.159 238.211l-19.544-7.777 4.311-5.374 11.954 4.758 3.279 8.393zM912.17 258.766l-38.1-15.153 4.302-5.386 30.53 12.147 3.268 8.392zM916.012 270.563a1.064 1.064 0 01-.934.291l-26.277-4.017-25.274-10.056 4.3-5.375z"
});

var _ref32 = /*#__PURE__*/React.createElement("circle", {
  cx: 896.231,
  cy: 213.233,
  r: 9.019,
  fill: "#899689"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M607.291 200h-14.984a4.5 4.5 0 01-4.389-5.494l2.775-12.247C555.085 176.47 528.3 137.573 528.3 91.5c0-50.453 32.075-91.5 71.5-91.5s71.5 41.047 71.5 91.5c0 46.073-26.786 84.97-62.394 90.76l2.775 12.246a4.5 4.5 0 01-4.389 5.494z",
  fill: "#ff6584"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M613.3 186h-24a3.5 3.5 0 010-7h24a3.5 3.5 0 110 7z",
  fill: "#3f3d56"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M588.283 181.637a24.776 24.776 0 00-21.35 4.586 24.331 24.331 0 00-8.864 19.915c.732 16.339 17.181 25.12 28.647 33.908 13.55 10.384 26.269 22.365 35.45 36.87 9.092 14.366 14.794 31.388 13.473 48.533-1.143 14.828-7.863 29.529-19.387 39.125a45.886 45.886 0 01-4.566 3.326c-1.62 1.04-.117 3.638 1.514 2.59 12.627-8.116 20.98-21.646 24.143-36.182 3.52-16.173.384-33.008-6.534-47.854-7.186-15.423-18.49-28.535-31.192-39.698-6.3-5.537-12.993-10.563-19.771-15.494-5.96-4.336-12.207-9.005-15.912-15.534a21.638 21.638 0 01-.226-21.063 21.213 21.213 0 0118.36-10.797 20.877 20.877 0 015.418.662c1.871.478 2.67-2.415.797-2.893z",
  fill: "#3f3d56"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M554.3 117a6.508 6.508 0 01-6.5-6.417 74.256 74.256 0 010-48.166 6.5 6.5 0 0113 .083l-.031.172c-5.683 15.49-5.683 31.525.002 47.662l.028.166a6.507 6.507 0 01-6.5 6.5z",
  fill: "#fff"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M980 594H1a1 1 0 010-2h979a1 1 0 010 2z",
  fill: "#3f3d56"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M444.124 514.3a31.517 31.517 0 01-30.434-5.362c-10.66-8.947-14.002-23.687-16.722-37.336l-8.043-40.37 16.84 11.595c12.11 8.339 24.493 16.945 32.878 29.023s12.045 28.566 5.308 41.635",
  fill: "#899689"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M442.685 563.176c1.704-12.415 3.457-24.99 2.261-37.538-1.062-11.144-4.461-22.029-11.383-30.953a51.491 51.491 0 00-13.211-11.972c-1.321-.834-2.537 1.26-1.222 2.09a48.952 48.952 0 0119.363 23.363c4.216 10.723 4.893 22.41 4.166 33.801-.439 6.888-1.37 13.731-2.308 20.565a1.254 1.254 0 00.845 1.489 1.218 1.218 0 001.489-.845z",
  fill: "#f2f2f2"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M426.268 541.207a23.2 23.2 0 01-20.215 10.433c-10.233-.485-18.764-7.627-26.444-14.408l-22.715-20.056 15.034-.719c10.811-.517 21.901-1 32.198 2.334s19.794 11.358 21.677 22.016",
  fill: "#899689"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M447.502 570.313c-8.204-14.516-17.72-30.649-34.722-35.805A38.746 38.746 0 00398.175 533c-1.55.134-1.163 2.524.385 2.39a35.996 35.996 0 0123.306 6.166c6.572 4.473 11.689 10.692 16.02 17.287 2.652 4.04 5.028 8.25 7.405 12.455.759 1.344 2.979.374 2.21-.985z",
  fill: "#f2f2f2"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M216.124 379.3a31.517 31.517 0 01-30.434-5.362c-10.66-8.947-14.002-23.687-16.722-37.336l-8.043-40.37 16.84 11.595c12.11 8.339 24.493 16.945 32.878 29.023s12.045 28.566 5.308 41.635",
  fill: "#e6e6e6"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M214.685 428.176c1.704-12.415 3.457-24.99 2.261-37.538-1.062-11.144-4.461-22.029-11.383-30.953a51.491 51.491 0 00-13.211-11.972c-1.321-.834-2.537 1.26-1.222 2.09a48.952 48.952 0 0119.363 23.363c4.216 10.723 4.893 22.41 4.166 33.801-.439 6.888-1.37 13.731-2.308 20.565a1.254 1.254 0 00.845 1.489 1.218 1.218 0 001.489-.845z",
  fill: "#f2f2f2"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M198.268 406.207a23.2 23.2 0 01-20.215 10.433c-10.233-.485-18.764-7.627-26.444-14.408l-22.715-20.056 15.034-.719c10.811-.517 21.901-1 32.198 2.334s19.794 11.358 21.677 22.016",
  fill: "#e6e6e6"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M219.502 435.313c-8.204-14.516-17.72-30.649-34.722-35.805A38.746 38.746 0 00170.175 398c-1.55.134-1.163 2.524.385 2.39a35.996 35.996 0 0123.306 6.166c6.572 4.473 11.688 10.692 16.02 17.287 2.652 4.04 5.028 8.25 7.405 12.455.759 1.344 2.979.374 2.21-.985z",
  fill: "#f2f2f2"
});

var SvgHappy2021 = function SvgHappy2021(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: 981,
    height: 594,
    viewBox: "0 0 981 594"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    },
    d: "M311.886 195h6v19h-6zM408.886 141h6v19h-6zM385.622 202.935l4.695-3.736 11.833 14.865-4.695 3.737zM352.538 273.227l9.5-16.454 5.196 3-9.5 16.454zM325.538 88.227l9.5-16.454 5.196 3-9.5 16.454zM719.886 157h6v19h-6zM816.886 103h6v19h-6zM793.622 164.935l4.695-3.736 11.833 14.865-4.695 3.737zM760.538 235.227l9.5-16.454 5.196 3-9.5 16.454zM733.538 50.227l9.5-16.454 5.196 3-9.5 16.454z"
  }), _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45);
};

export default __webpack_public_path__ + "static/happy_2021.ac4d7829.svg";
export { SvgHappy2021 as ReactComponent };